import React, { useState, useEffect } from 'react';
import { IoHomeOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
// React Icons
import { RiMailOpenLine } from "react-icons/ri";
import { IoMdTime } from "react-icons/io";
import { Link } from "react-router-dom";
import { HiBars3 } from "react-icons/hi2";
import { MdOutlineClose } from "react-icons/md";
import LoginModal from "./LoginModal";
import { FaWhatsapp } from "react-icons/fa";


import {
    FaInstagram, FaTelegram,
    FaPhoneAlt, FaArrowRight, FaChevronDown
} from "react-icons/fa";
import Logohome from "../assets/image/logo-1.png"

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [sticky, setSticky] = useState(false);
    const [dropdown, setDropdown] = useState(null);
    const [loginOpen, setLoginOpen] = useState(false);
    const navigate = useNavigate();


    const toggleDropdown = (menu) => {
        setDropdown(dropdown === menu ? null : menu);
    };

    useEffect(() => {
        const scrollHandler = () => {
            setSticky(window.scrollY > 50);
        };
        window.addEventListener("scroll", scrollHandler);
        return () => window.removeEventListener("scroll", scrollHandler);
    }, []);

    const navItems = [
        {
            title: "HOME", link: "/",
        },
        {
            title: "ABOUT", link: "/about-us",
        },
        {
            title: "SERVICES", link: "/services",
        },
        { title: "CONTACT", link: "/contact-us", },

    ];
    const handleLoginOpen = () => {
        const token = localStorage.getItem("token");
        const expiry = localStorage.getItem("tokenExpiry");

        if (token && expiry && Date.now() < Number(expiry)) {
            navigate("/dashboard");
            return;
        }

        setLoginOpen(true);
    };

    return (
        <header className="w-full fixed z-[99]">

            {/* TOP BAR */}
            <div className="bg-[#162e40] text-white p-2 border-b border-slate-800 ">
                <div className="max-w-7xl mx-auto flex justify-center md:justify-between items-center px-4 flex">
                    <div className="flex flex-wrap text-xs md:text-sm  space-x-4 md:space-x-6 py-3 hidden sm:flex">
                        <div className="flex items-center space-x-2 border-r pr-3 border-[#fff]">
                            <IoHomeOutline className="text-red-500 text-[20px]" />
                            <span className="text-[15px] open-sans">209-1390 Prince of Wales Dr, Ottawa, ON, K2C 3N6</span>
                        </div>
                        <div className="hidden md:flex items-center space-x-2 border-r pr-3 border-[#fff]">
                            <RiMailOpenLine className="text-red-500 text-[20px]" />
                            <span className="text-[15px] open-sans">info@trinitymanagementservices.ca</span>
                        </div>
                        <div className="hidden lg:flex items-center space-x-2 border-r pr-3 border-[#fff]">
                            <IoMdTime className="text-red-500 text-[20px]" />
                            <span className="text-[15px] open-sans">Mon - Sat : +1 (438) 927-2958</span>
                        </div>
                    </div>

                    <div className="flex gap-4 text-white">
                        <a
                            href="https://t.me/trinitymanagementservices"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-red-500 cursor-pointer"
                        >
                            <FaTelegram />
                        </a>

                        <a
                            href="https://www.instagram.com/trinitymanagementservices.ca/?igsh=MTlvdXppZ2txOXNjbQ%3D%3D"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-red-500 cursor-pointer"
                        >
                            <FaInstagram />
                        </a>
                        <a
                            href="https://wa.me/message/DUQL24HZRZGOC1"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-red-500 cursor-pointer"
                        >
                            <FaWhatsapp />
                        </a>
                    </div>
                </div>

            </div>

            {/* MAIN NAVBAR */}
            <nav className={`${sticky ? "fixed top-0 left-0 w-full shadow-lg bg-[#162e40] border-[#162e40] py-2 lg:py-1" : ""} transition-all duration-300 z-50 border-b border-[#a9a2a2]`}>
                <div className="max-w-7xl mx-auto px-4 ">
                    <div
                        className={`flex items-center py-2 
                 ${sticky ? "justify-between md:justify-around" : "justify-between"}`}
                    >
                        {/* Logo + Appointment */}
                        <div className="flex items-center space-x-6">
                            <div className="text-white text-3xl font-bold flex items-center space-x-2">
                                <Link to="/" className="w-[120px]">
                                    <img src={Logohome} className="w-full rounded-[5px]" alt="Website Logo" />
                                </Link>
                            </div>






                        </div>

                        {/* Desktop Menu */}
                        <div className="flex items-center gap-10">
                            <div className="flex items-center hidden lg:flex items-center space-x-6 text-sm font-medium">
                                {navItems.map((item, index) => (
                                    <div key={index} className="relative group">
                                        <Link to={item.link} className="cabin mr-3 mb-0 text-[18px] tracking-[1px] text-white hover:text-red-500 transition border-b-4 border-transparent flex items-center">
                                            {item.title}
                                        </Link>


                                        {/* Dropdown */}
                                        {item.sub && (
                                            <div
                                                className={`
            absolute top-full left-0 bg-white shadow-md w-48 py-2
            opacity-0 translate-y-3 pointer-events-none
            group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto
            transition-all duration-300 ease-out
        `}
                                            >
                                                {item.sub.map((sub, i) => (
                                                    <Link
                                                        to={sub.link}
                                                        key={i}
                                                        className="block cabin px-4 py-2 text-black hover:bg-slate-700 hover:text-red-500 text-sm"
                                                    >
                                                        {sub.label}
                                                    </Link>

                                                ))}


                                            </div>


                                        )}



                                    </div>

                                ))}
                            </div>

                            <button
                                onClick={handleLoginOpen}

                                className="cabin mr-3 mb-0 hidden lg:flex  text-[18px] font-[500] tracking-[1px] text-white hover:text-red-500 transition border-b-4 border-transparent flex items-center 
                                "
                            > LOGIN
                            </button>



                            <button className={`bg-red-500 hover:bg-red-600 text-white p-4  items-center space-x-3 
  ${sticky ? "hidden" : "hidden xl:flex"}`}>
                                <div className="rounded-full text-[#162e40]  bg-[#fff] p-2">
                                    <FaPhoneAlt className="rotate-12" />
                                </div>
                                <div>
                                    <span className="text-xs block open-sans">Any Questions? Call us</span>
                                    <span className="text-xl font-bold open-sans">+1 (438) 927-2958</span>
                                </div>
                            </button>

                            <Link to="/contact-us"
                                className={`cabin gap-2 items-center hover:bg-[#ef4444]  transition-all duration-500 ease-in-out h-12 px-6 outline-none border-[1px] border-[#fff] hover:border-[#ef4444]    
                            text-white transition ${sticky ? "hidden" : "hidden sm:flex"}`}
                            >
                                Appointment <FaArrowRight />
                            </Link>


                        </div>

                        {/* Mobile Section */}
                        <div className="flex items-center lg:hidden">
                            <button
                                onClick={() => setIsOpen(true)}
                                className="p-2 rounded-md text-white hover:text-red-500"
                            >
                                <HiBars3 size={30} />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile Sidebar */}
                {/* Mobile Sidebar */}
                <div className={`fixed inset-0 z-50 flex justify-end transition-all duration-300 
    ${isOpen ? "bg-black/60 visible" : "bg-black/0 invisible"}`}>

                    {/* Sidebar Panel */}
                    <div className={`w-80 bg-[#162e40] h-full text-white py-5 overflow-y-auto
        transform transition-transform duration-300 
        ${isOpen ? "translate-x-0" : "translate-x-full"}`}>

                        {/* Header */}
                        <div className="flex items-center justify-between mb-3 px-4">
                            <div className="flex items-center gap-2 text-2xl font-bold">
                                <Link to="/home" className="w-[120px]"><img src={Logohome} className="w-full" alt="Website Logo" /></Link>
                            </div>

                            <button className="block" onClick={() => setIsOpen(false)}>
                                <MdOutlineClose size={30} />
                            </button>
                        </div>

                        {/* Menu */}
                        <div className="flex flex-col">
                            {navItems.map((menu, i) => (
                                <div key={i} className="border-t border-[#3b5467]">

                                    <div className="flex justify-between items-center cabin px-4 py-3">
                                        <Link
                                            to={menu.link}
                                            className="text-white text-[17px]"
                                            onClick={() => setIsOpen(false)}
                                        >
                                            {menu.title}
                                        </Link>

                                        {menu.sub && (
                                            <button
                                                className="p-2 bg-[#373737] rounded-sm"
                                                onClick={() => toggleDropdown(menu.title)}
                                            >
                                                <FaChevronDown
                                                    className={`transition-transform duration-300 ${dropdown === menu.title ? "rotate-180" : "rotate-0"
                                                        }`}
                                                />
                                            </button>
                                        )}
                                    </div>




                                    {menu.sub && dropdown === menu.title && (
                                        <div className="ml-4 my-2 text-sm">
                                            {menu.sub.map((s, idx) => (
                                                <Link
                                                    key={idx}
                                                    to={s.link}
                                                    className="block px-4 py-2 cabin"
                                                    onClick={() => setIsOpen(false)}
                                                >
                                                    {s.label}
                                                </Link>
                                            ))}
                                        </div>


                                    )}


                                </div>


                            ))}

                            <button
                                onClick={() => {
                                    handleLoginOpen();
                                    setIsOpen(false);
                                }}
                                className="text-white text-[17px] cabin px-4 py-3 text-left"
                            >
                                LOGIN
                            </button>
                        </div>

                        {/* Bottom Info */}
                        <div className="mt-6 text-sm px-4">
                            <p className="flex gap-2 items-center text-[15px] open-sans">
                                <IoHomeOutline className="text-red-500 text-[20px]" />209-1390 Prince of Wales Dr, Ottawa, ON, K2C 3N6
                            </p>

                            <p className="flex gap-2 items-center mt-2 text-[15px] open-sans">
                                <RiMailOpenLine className="text-red-500 text-[20px]" />info@trinitymanagementservices.ca
                            </p>

                            <p className="flex gap-2 items-center mt-2 text-[15px] open-sans">
                                <IoMdTime className="text-red-500 text-[20px]" />Mon - Fri : +1 (438) 927-2958
                            </p>
                        </div>

                    </div>
                </div>


            </nav>

            <LoginModal
                open={loginOpen}
                onClose={() => setLoginOpen(false)}
            />

        </header>
    );
};

export default Header;